{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              172.9259179845477,
              -33.98979270724431
            ],
            [
              166.45522140999879,
              -39.983220373016394
            ],
            [
              162.69468233217276,
              -49.847358442405074
            ],
            [
              168.90601878323594,
              -53.37899143089624
            ],
            [
              184.61019257578482,
              -44.53949595560419
            ],
            [
              180.25281432936225,
              -37.169078415394836
            ],
            [
              172.9259179845477,
              -33.98979270724431
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}